import styled from 'styled-components';

const ItemContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export default ItemContainer;
